<template>
  <div>
    <div id="rules">
      <ApplyButton class="button" v-bind:buttonText="buttonText" @click="func" />
      <div class="extra"></div>
      <rule v-for="(item, index) in rules" :key="index" :rule="item" class="column"></rule>
    </div>
  </div>
</template>

<script>
import ApplyButton from "@/components/global-components/ApplyButton";
import rules from "@/assets/resources/rules.js";
import rule from "@/components/registration-components/Rule";
export default {
  components: {
    rule,
    ApplyButton,
  },
  data() {
    return {
      rules,
      buttonText: "APLICĂ ACUM",
    };
  },
  methods: {
    func() {
      location.href='https://docs.google.com/forms/d/e/1FAIpQLSdeymd4Sx3EuTwJrfToca8ye76Iuu2tDr4sQuXEA-mfUgJ9Lw/viewform';
    },
  },
};
</script>

<style lang="scss" scoped>
#rules {
  background-color: #0d2a4c;
  padding-bottom: 10vh;
}

.button {
  background: transparent;
  border: transparent;
  position: relative;
  top: -40vh;
  z-index: 100;
}
@media screen and (max-width: 1024px) {
  #rules {
    padding-top: 11.5vh;
  }
  .extra {
    height: 13vh;
  }
  .button {
    position: static;
    margin-top: 0vh;
    top: none;
  }
}
</style>